import { render, staticRenderFns } from "./Traitement.vue?vue&type=template&id=e59405a6&"
import script from "./Traitement.vue?vue&type=script&lang=js&"
export * from "./Traitement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e59405a6')) {
      api.createRecord('e59405a6', component.options)
    } else {
      api.reload('e59405a6', component.options)
    }
    module.hot.accept("./Traitement.vue?vue&type=template&id=e59405a6&", function () {
      api.rerender('e59405a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pacs008/SDD/Traitement.vue"
export default component.exports